/**
 * CopyToast — transient bottom-center toast that fades out after ~2s.
 */

interface CopyToastProps {
  message: string;
  show: boolean;
}

export default function CopyToast({ message, show }: CopyToastProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: "fixed",
        bottom: "calc(72px + env(safe-area-inset-bottom, 0px))",
        left: "50%",
        transform: "translateX(-50%)",
        background: "var(--tg-text)",
        color: "var(--tg-bg)",
        padding: "8px 20px",
        borderRadius: "20px",
        fontSize: "14px",
        fontWeight: 600,
        whiteSpace: "nowrap",
        pointerEvents: "none",
        zIndex: 9999,
        opacity: show ? 1 : 0,
        transition: "opacity 0.2s ease",
      }}
    >
      {message}
    </div>
  );
}
